// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"layout-module--mainContainer--1xNSn"};